import api from './api'

export async function fetchAdminPolicies(params = {}) {
  const { data } = await api.get('/admin/policies', { params })
  return {
    policies: data?.data ?? [],
    pagination: data?.pagination ?? null,
  }
}

export async function fetchAdminPolicy(id) {
  const { data } = await api.get(`/admin/policies/${id}`)
  return data?.data ?? null
}

export async function createAdminPolicy(payload) {
  const { data } = await api.post('/admin/policies', toFormData(payload))
  return data?.data ?? null
}

export async function updateAdminPolicy(id, payload) {
  const { data } = await api.put(`/admin/policies/${id}`, toFormData(payload))
  return data?.data ?? null
}

export async function deleteAdminPolicy(id) {
  const { data } = await api.delete(`/admin/policies/${id}`)
  return data
}

export async function setAdminPolicyActive(id, isActive) {
  const { data } = await api.patch(`/admin/policies/${id}/active`, { is_active: isActive })
  return data?.data ?? null
}

export async function regenerateAdminPolicyLink(id) {
  const { data } = await api.post(`/admin/policies/${id}/regenerate-link`)
  return data?.data ?? null
}

export async function fetchAdminPolicySignatures(id) {
  const { data } = await api.get(`/admin/policies/${id}/signatures`)
  return data?.data ?? []
}

export async function sendPolicyInvite(id, payload) {
  const { data } = await api.post(`/admin/policies/${id}/send-invite`, payload)
  return data
}

// The backend accepts multipart for create/update so a document file can be
// uploaded alongside the text fields. _method is unnecessary because PUT is
// routed directly; FormData keeps the file intact.
function toFormData(payload) {
  const form = new FormData()
  const entries = {
    name: payload.name,
    description: payload.description,
    body_html: payload.body_html,
    is_active: payload.is_active,
  }

  Object.entries(entries).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      form.append(key, typeof value === 'boolean' ? (value ? '1' : '0') : value)
    }
  })

  if (payload.file) {
    form.append('file', payload.file)
  }

  return form
}
